import React from "react";
import { Tag } from "@blueprintjs/core";

class CategoryList extends React.Component {
  render() {
    var rows = [];
    this.props.data.map((value, index) => {
      rows.push(
        <Tag
          key={index}
          style={{ cursor: "pointer", margin: "2px" }}
          intent={this.props.selectedIndex === index ? "primary" : "none"}
          onClick={() => this.props.CategoryNameAndIndex(value.category, index)}
        >
          {value.category}
        </Tag>
      );
    });

    return <div>{rows}</div>;
  }
}

export default CategoryList;
